export default defineNuxtPlugin(() => {
  const router = useRouter();
  const uiStore = useUiStore();

  router.beforeEach((to, from, next) => {
    if (from.name) {
      uiStore.setLastRoute(from.fullPath);
    }
    next();
  });
});
